import API from '@/api/apiUrls'
import { useApi } from '@/api/useApi'
import type { OpengroundBackendAdapter } from '@haskoning/vue-speckle'

const { api } = useApi()

export const opengroundAdapter: OpengroundBackendAdapter = {
  getProjectMetadata: async (accessToken: string) => {
    const response = await api.service(API.OPENGROUND.PROJECT_METADATA).find({
      query: { access_token: accessToken }
    })
    return response.data
  },
  getAccessToken: async (context) => {
    const response = await api.service(API.OPENGROUND.ACCESS_TOKEN).create({
      redirect_uri: context.callbackURL,
      client_id: context.clientId,
      code: context.code,
      code_verifier: context.codeVerifier,
      token_url: context.tokenUrl
    })
    return response.access_token
  },
  getLocationGIs: async (params) => {
    const response = await api.service(API.OPENGROUND.GI_LOCATIONS).find({
      query: {
        access_token: params.accessToken,
        project_id: params.projectId
      }
    })
    return response.data
  },
  exportToSpeckle: async (params) => {
    const response = await api.service(API.OPENGROUND.EXPORT_OPENGROUND_TO_SPECKLE).create({
      openground_token: params.opengroundToken,
      speckle_token: params.speckleToken,
      openground_project_id: params.opengroundProjectId,
      openground_location_ids: params.opengroundLocationIds,
      speckle_project_id: params.speckleProjectId,
      speckle_model_name: params.speckleModelName,
      speckle_commit_message: params.speckleCommitMessage,
      primary_geology_code_field: params.primaryGeologyCodeField
    })
    return response
  },
  pollTaskStatus: async (taskId: string) => {
    const response = await api.service(API.OPENGROUND.TASK_STATUS(taskId)).get()
    return response
  }
}
